const allFlagImages = {};

// check which jpeg images are present and save them in a global var
let r = require.context('@/assets/images/flags/', false, /\.svg/);
r.keys().forEach((key) => {
	allFlagImages[key.split('/').pop().slice(0, -4)] = r(key);
});

export function getFlagImages() {
	return allFlagImages;
}
